import SignOut from 'containers/SignOut'
export default SignOut
